import styled, {css} from 'styled-components'

const iconTypeStyle = ({isDismissed, isDestructive}) => {
  if (isDismissed){
    return css`
      background-color: ${isDestructive? 'rgba(225, 25, 0, 0.05)' : 'rgba(10, 161, 244, 0.05)'}; 
      
      path {
        fill: ${isDestructive? '#E11900' : ' #0AA1F4'};
        fill-opacity: 1;
      }
    `
  }

  return css`
    background-color: ${isDestructive? 'rgba(225, 25, 0, 1)' : 'rgba(10, 161, 244, 1)'};  
  `
}

export const TopBarNotificationIcon = styled.div`
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-radius: 50%;  
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;

  :hover {
    background: rgba(32, 32, 32, 0.05);
  }
`

export const TopBarNotificationMenuWrapper = styled.div`
  display: ${(p) => {
    return p.open ? 'block' : 'none'
  }};
  position: absolute;
  right: 0;
  top: 72px;
  min-height: 176px;
  width: 340px;
  border-radius: 8px;
  background: white;
  border: 1px solid rgba(32, 32, 32, 0.1);
  z-index: 500;
`

export const TopBarNotificationMenuHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  border-bottom: 1px solid rgba(32, 32, 32, 0.1);

  > div {
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    font-family: 'Inter';
  }

  div:last-child {
    margin-right: 0;
  }
`

export const TopBarNotificationWrapper = styled.div`
  height: 100%;
  width: 88px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const TopBarNotificationMenuNotificationsListNoNotifications = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;

  > svg {
    margin-top: 36px;
    margin-left: auto;
    margin-right: auto;
    height: 24px;
    width: 24px;
  }

  > div {
    margin-top: 16px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: rgba(32, 32, 32, 0.7);
  }
`

export const TopBarNotificationMenuNotificationsList = styled.div`
  max-height: 376px;
  overflow-y: scroll;
`

export const TopBarNotificationMenuItem = styled.div`
  width: 100%;  
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 24px; 
  border-left: ${(p) => {
    return p.isDismissed ? '2px solid #fff' : '2px solid #0AA1F4'
  }};
`

export const NotificationDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgba(32, 32, 32, 0.1);
`

export const TopBarNotificationMenuItemIcon = styled.div`
  min-height: 32px;
  min-width: 32px;
  border-radius: 50%;  
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  ${iconTypeStyle}
`

export const TopBarNotificationMenuItemText = styled.div`
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  font-family: 'Inter';
`

export const NotificationsAmount = styled.div`
  position: absolute;
  top: -8px;
  right: 8px;
`

export const TopBarNotificationText = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`

export const TopBarNotificationContainer = styled.div`
  position: relative;
`

export const NotificationLink = styled.a`
  font-weight: 500;
  color: #0AA1F4;
  text-decoration: none;  
`

export const NotificationTime = styled.div`
  margin-top: 8px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: rgba(32, 32, 32, 0.5);
`
